import React, { Suspense, lazy } from "react";
import Navbar from "components/Navbar";
import "app.scss";

const Main = () => {
  return (
    <>
      <Navbar />
      <div className="container " style={{ marginTop: "20px" }}>
        <Suspense
          fallback={
            <div className="spinner-container">
              <div
                className="spinner-border custom-spinner"
                role="status"
              ></div>
            </div>
          }
        >
        </Suspense>
      </div>
    </>
  );
};

export default Main;

